import { render, staticRenderFns } from "./HomePassageiro.vue?vue&type=template&id=39001c74&"
import script from "./HomePassageiro.vue?vue&type=script&lang=js&"
export * from "./HomePassageiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports